/* Movatic WMS — Frontend | CesarFilho 932048016 */
import CrudList from '@/components/CrudList'

export default function RiskTypes() {
  return (
    <CrudList
      title="Matriz de risco"
      endpoint="/api/workforce/risk-types/"
      writable
      columns={[
        { key: 'code', header: 'Código' },
        { key: 'name', header: 'Nome' },
        { key: 'block_scope', header: 'Âmbito' },
        { key: 'in_progress_action', header: 'Em curso' },
        { key: 'alert_level', header: 'Alerta' },
        { key: 'is_active', header: 'Ativo' },
      ]}
    />
  )
}
